import React, { useEffect, useState } from "react";
import Form from "../../../../Components/Form";
import UsersMultiSelectDropdown from "../../../../Components/Dropdown/Users/UsersMultiSelectDropdown";
import {
  IGetOrdersDTO,
  IPairPositionReport,
} from "../../../../Interfaces/optionDomain";
import TextInput from "../../../../Components/TextInput";
import StaticDropdown from "../../../../Components/Dropdown/StaticDropdown";
import { DropdownItem } from "../../../../Interfaces/dropdownInterfaces";
import { getStepInstruments } from "../../../../Requests/stepRequests";
import { packetErrorHandler } from "../../../../Utils/requestUtils";
import Button from "../../../../Components/Button";
import { getOrders } from "../../../../Requests/optionDomain";
import { INLegsAddOrderFormValues } from "../../../../Interfaces/nLegsInterfaces";
import Modal from "../../../../Components/Modal/Modal";
import SahraConnections from "../../../../Pages/Sahra/SahraConnections";
import { addNLegOrder } from "../../../../Requests/nLegsRequests";
import { toast } from "react-toastify";
import NLegOrderPreviewTable from "./NLegOrderPreviewTable";
import DynamicMultiSelectDropdown from "../../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getDeltaHedgeAccountsDropdown } from "../../../../Requests/deltaHedgeAccounts";

interface IProps {
  row: IPairPositionReport;
  onAction: () => void;
}

enum ModalMode {
  Closed,
  SahraOrderTable,
  OrderPreview,
}

const SendRequestConfig = ({ row, onAction }: IProps) => {
  const [formValues, setFormValues] = useState({
    price: parseFloat(row.priceValue?.replaceAll(",", "")),
    ratio2: row.hedgeFactor?.replaceAll(",", ""),
    ratio1: "1",
    instrumentId1: row.instrumentId1,
    instrumentId2: row.instrumentId2,
    instrumentName1: row.instrumentName1,
    instrumentName2: row.instrumentName2,
    involvedFund: row.involvedFund?.replaceAll(",", ""),
    contractSize1: row.contractSize1?.replaceAll(",", ""),
    contractSize2: row.contractSize2?.replaceAll(",", ""),
    orderSide1: row.orderSideValue1,
    orderSide2: row.orderSideValue2,
  } as IGetOrdersDTO);

  const [instrumentOptions, setInstrumentOptions] = useState(
    [] as DropdownItem[]
  );
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([] as INLegsAddOrderFormValues[]);

  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setInstrumentOptions(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    getOrders(formValues)
      .then((resp) => {
        setOrders(resp);
        setModalMode(ModalMode.OrderPreview);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  const sendNlegOrders = () => {
    const requests = orders.map((order) => addNLegOrder(order));
    setLoading(true);
    Promise.all(requests)
      .then(() => {
        toast.success("با موفقیت انجام شد");
        onAction();
        setModalMode(ModalMode.Closed);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const sahraUserTableModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <SahraConnections
        initialSearchParam={{
          userIds: formValues.accountIds,
        }}
      />

      <div className="w-[100px] mr-auto">
        <Button text="ثبت" variant="contained" onClick={sendNlegOrders} />
      </div>
    </div>
  );

  const orderPreviewModalUI = (
    <div className="flex flex-col justify-start items-center gap-3">
      <NLegOrderPreviewTable values={orders} />

      <div className="w-[100px] mr-auto">
        <Button
          text="ثبت"
          variant="contained"
          onClick={() => setModalMode(ModalMode.SahraOrderTable)}
        />
      </div>
    </div>
  );

  const getModalMode = () => {
    switch (modalMode) {
      case ModalMode.Closed:
        return <></>;

      case ModalMode.SahraOrderTable:
        return sahraUserTableModalUI;

      case ModalMode.OrderPreview:
        return orderPreviewModalUI;

      default:
        return <></>;
    }
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2 !mx-auto">
      {modalMode !== ModalMode.Closed ? (
        <Modal title={modalMode === ModalMode.SahraOrderTable ? "اتصالات صحرا" : "پیش‌نمایش سفارش"}
          onClose={() => setModalMode(ModalMode.Closed)}
          UI={getModalMode()}
        />
      ) : (
        <></>
      )}
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "accountIds",
          placeholder: "اکانت ها",
          extraLabel: true,
        }}
        value={formValues.accountIds}
        onChange={changeHandler}
        getData={getDeltaHedgeAccountsDropdown}
        withSelectAll
      />
      <TextInput
        label="نسبت"
        value={`1 : ${row.hedgeFactor}`}
        name=""
        onChange={() => {}}
        disabled
        extraLabel
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت اول",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId1}
        options={instrumentOptions}
      />
      <StaticDropdown
        onChange={changeHandler}
        dropdown={{
          name: "",
          placeholder: "نماد جهت دوم",
          disabled: true,
          extraLabel: true,
        }}
        value={row.instrumentId2}
        options={instrumentOptions}
      />
      <TextInput
        label="حداکثر بهای تمام شده"
        value={formValues.price?.toString()}
        name="price"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="درصد از پورتفو"
        value={formValues.assetPercent?.toString()}
        name="assetPercent"
        onChange={changeHandler}
        extraLabel
      />
      <Button text="ثبت" variant="contained" onClick={submitHandler} />
    </Form>
  );
};

export default SendRequestConfig;
